module.exports = {
  backgroundImage: '/webapp/img/land/hero.jpeg',
  locale: 'en',
  dense: true,
  footer: true,
  navbar: {
    show: true,
    dense: false,
    logo: true,
  },
  fullscreen: {
    show: false,
    btn: true,
  },
  settingsPanel: {
    show: false,
    btn: false,
  },
  theme: {
    index: 0,
    dark: false,
  },
  maxNoticesDisplay: 3
}
